<template>
  <split-panel-page v-if="packages && profiles" :scroll="false" >
    <content-nav-bar>
      <h5 class="is-size-4 level-item">Create Deployment Package</h5>
      <a v-on:click="submit()" class="add button level-item">
        <i class="far fa-save"></i>
        Save
      </a>
      <loader class="level-item" :showLoader="showLoader">Creating Deployment Package</loader>
    </content-nav-bar>
    <div class="field deployment-form full-height-scroll">
      <div>
        <form-field icon="name" title="Deployment Name">
          <input v-model="name"
          class="input"
          type="text"
          placeholder="Name">
        </form-field>

        <form-field icon="pkg" title="Base Package">
          <multiselect
            v-model="pkg"
            :options="pkgs"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            label="name"
            track-by="uuid"
            placeholder="Pick an Package">
          </multiselect>
        </form-field>

        <form-field icon="profile" title="Profile">
          <multiselect
            v-model="profile"
            :options="profiles.items"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            label="name"
            track-by="id"
            placeholder="Pick a Profile">
          </multiselect>
        </form-field>
      </div>
    </div>
    <template slot="right">
      <content-nav-bar>
        <h5 class="is-size-4 has-text-centered level-item">Deployment Package Details</h5>
      </content-nav-bar>
      <div class="full-height-scroll">
        <tile-package v-if="pkg" :pkg="pkg"></tile-package>
        <tile-profile
          v-if="profile"
          :profile="profile"
          :title="`Profile - ${profile.name}`"
          class="is-info">
        </tile-profile>
      </div>
    </template>
  </split-panel-page>
</template>

<script>
import _ from 'lodash';
import ContentNavBar from '@/components/ContentNavBar.vue';
import Loader from '@/components/Loader.vue';
import Multiselect from 'vue-multiselect';
import SplitPanelPage from '@/components/SplitPanelPage.vue';
import TileProfile from '@/components/profiles/tiles/TileProfile.vue';
import TilePackage from '@/components/deployments/tiles/TilePackage.vue';
import FormField from '@/components/forms/FormField.vue';


export default {
  name: 'DeploymentCreate',
  components: {
    SplitPanelPage,
    ContentNavBar,
    Loader,
    Multiselect,
    TileProfile,
    TilePackage,
    FormField,
  },
  async mounted() {
    this.packages = await this.$store.dispatch('primary/listPackages', {
      direction: 'DESC',
      field: 'created',
    });
    this.profiles = await this.$store.dispatch('primary/listProfiles', {
      direction: 'DESC',
      field: 'created',
    });
  },
  computed: {
    payload() {
      return {
        name: this.name,
        profile: ((this.profile !== null) ? this.profile.id : null),
        package: ((this.pkg !== null) ? this.pkg.uuid : null),
      };
    },
    pkgs() {
      if (this.packages) {
        return _.map(this.packages.items, pkg => (_.extend({ name: `${pkg.major}.${pkg.minor}.${pkg.build}` }, pkg)));
      }
      return [];
    },
  },
  methods: {
    async submit() {
      this.showLoader = true;
      const deployment = await this.$store.dispatch('primary/createDeployment', this.payload);
      this.showLoader = false;
      if (deployment) {
        this.$router.push({ name: 'deployments.index' });
      }
    },
  },
  data() {
    return {
      showLoader: false,
      packages: null,
      profiles: null,
      name: '',
      pkg: null,
      profile: null,
    };
  },
};
</script>

<style lang="scss" scoped>

.deployment-form {
  padding: 0 $content-padding;

  .field {
    padding: $content-padding 0;
  }
}

.content-wrapper {
  flex-direction: row;
}

.form-wrapper {
  flex-grow: 1;
}

.help-section {
  flex-basis: $info-panel-width;
  border-left: 1px solid $border-color;
}

.full-height-scroll {
  flex-grow: 1;
  height: 100%;
  padding-bottom: 2rem;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
